import { Progress } from '@ark-ui/react'

export const LinearProgressBar = ({ value }: { value: number }) => {
    return (
        <Progress.Root value={value} className="w-full max-w-md rounded-[20px] h-[14px]">
            <Progress.Track className="w-full h-full bg-white/10 rounded-[20px] overflow-hidden">
                <Progress.Range className="h-full rounded-[20px] transition-all duration-300 bg-muse-primary-gradient" />
            </Progress.Track>
        </Progress.Root>
    )
}
